import styled from 'styled-components';
import { Flex } from '@lideralia/alife-uikit/dist/atoms/Layout';

export const SectionStyled = styled(Flex)({
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});
